(ns iris.posts.views.thread-alert
  (:require
   [re-frame.core :as re-frame]
   [reagent.core :as reagent :refer [atom]]
   [iris.globals :as globals]
   [iris.utils :as utils]
   [clojure.string :as string]
   [iris.auth.api :as auth]
   [iris.data.api :as data]
   [cljs.core.async :refer [go go-loop timeout <! take!]]
   [cljs.core.async.interop :refer-macros [<p!]]
  ;;  [herb.core :refer [<class <id]]
   [iris.styles.thread-alerts :as $styles]
   [iris.events :as events]
   [iris.subs :as subs]
   [goog.html.utils :refer [stripHtmlTags]]

   [iris.worker-pool :as worker-pool]
   ))



;; Note:
;; pause and last action ts are needed in case get-thread-alert runs at the same time with "close" action
;; otherwise alert dissapears than reappears until the next tick
(defonce pause-int 5000)
(defonce ts-last-action (atom nil))


;; (defn get-thread-alerts []
;;   (go
;;     (let [fall (<p! (firebase/<p-get-all-thread-follow))]
;;       (loop [fall-keys (keys fall)
;;              alerts []]
;;         (if-not (empty? fall-keys)
;;           (let [f ((first fall-keys) fall)
;;                 replies (<p! (firebase/<p-get-replies (:ws f) (:id f)))]
;;             (if (> (:t replies) (:t f))
;;               (recur (rest fall-keys) (conj alerts (assoc f :t (:t replies))))
;;               (recur (rest fall-keys) alerts)))
;;           (when (or (nil? @ts-last-action)
;;                     (> (- (.getTime (new js/Date)) @ts-last-action) pause-int))
;;             (re-frame/dispatch [::events/set-alerts (into [] (sort-by :t #(compare %2 %1) alerts))])))))))


(defn set-thread-alerts [result-data]
  (let [alerts (:result result-data)]
    (re-frame/dispatch [::events/set-alerts (into [] (sort-by :t #(compare %2 %1) alerts))])))

(defn get-thread-alerts [uid pause-int ts-last-action]
  (println "get-thread-alerts")
  (take! (worker-pool/do! {:handler :get-thread-alerts, :arguments {:uid uid :pause-int pause-int :ts-last-action ts-last-action}}) set-thread-alerts))


(defn on-click-show-all [e value]
  (.preventDefault e)
  (re-frame/dispatch [::events/set-alerts-show-all value]))


(defn on-click-delete-all [e alerts]
  (.preventDefault e)
  (doseq [a alerts]
    (data/set-thread-follow-t (:id a) (:t a))
    (re-frame/dispatch [::events/remove-alert (:id a)]))
  (reset! ts-last-action (.getTime (new js/Date))))


(defn close [e a]
  (.preventDefault e)
  (data/set-thread-follow-t (:id a) (:t a))
  (re-frame/dispatch [::events/remove-alert (:id a)])
  (reset! ts-last-action (.getTime (new js/Date))))


(defn on-click-alerts-popup [e value]
  ;; must not prevent default because it affects other btns on the page
  ;; (.preventDefault e)
  (re-frame/dispatch [::events/popup-alerts value]))


;; handling outside click - start
(defonce ref-dom-node (atom nil))

(defn ref-event-handler [ref]
  (reset! ref-dom-node ref))

(defn on-click-document [e]
  (when (and @ref-dom-node
             (false? (.contains @ref-dom-node (.-target e))))
    (on-click-alerts-popup e false)))

(defn on-click-alert-link [e a]
  ;; when the current alert link's pathname is the same as current window pathname
  ;; in other words, we received an alert for the thread we are currently on
  ;; execute redo events - the reason for that is the route will not change (pathname is the same)
  ;; and therefore data load will not get triggered
  (when (= (.. e -target -pathname)
           (.. js/window -location -pathname))
    (.preventDefault e)
    (re-frame/dispatch [::events/redo]))
  (close e a))

(defn thread-alert []
  (reagent/create-class
   {:display-name  "thread-alert"
    :component-did-mount (fn [this]
                           (.addEventListener js/document "click" on-click-document true))
    :component-will-unmount (fn [this]
                              (.removeEventListener js/document "click" on-click-document true))
    :reagent-render
    (fn []
      (fn []
        (let [alerts-popup (re-frame/subscribe [::subs/alerts-popup])
              alerts (re-frame/subscribe [::subs/alerts])
              show-all (re-frame/subscribe [::subs/alerts-show-all])]
          [:div {:ref #(ref-event-handler %)}
           [:button {:title "Thread Alerts"
                     :class
                    ;;  (str "btn " (<class $styles/alert-list-btn))
                     $styles/$alert-list-btn
                     :on-click (fn [e] (on-click-alerts-popup e (not @alerts-popup)))}
            [:i {:class "bi bi-bell"}]
            (when (> (count @alerts) 0) [:span {:class
                                                ;; (str "badge " (<class $styles/alert-list-btn-badge))
                                                $styles/$alert-list-btn-badge
                                                } (count @alerts)])]
           (when (true? @alerts-popup)
             (if (= (count @alerts) 0)
               [:div {:class
                      ;; (<class $styles/alert-list-empty)
                      $styles/$alert-list-empty
                      } "No new notifications"]
               [:div {:class
                      ;; (<class $styles/alert-list)
                      $styles/$alert-list
                      }
                (for [a (if (true? @show-all) @alerts (take 3 @alerts))]
                  (let [forum-path-txt (:forumPath a)
                        time-ago (utils/dt2ago (.toISOString (new js/Date (* (:t a) 1000))) true)
                        link-txt (stripHtmlTags (:title a))]
                    [:div {:key (:id a)
                           :class
                            ;; (<class $styles/alert)
                           $styles/$alert
                           }
                     [:button {:class
                              ;;  (<class $styles/close-btn)
                               $styles/$close-btn
                               :on-click (fn [e] (close e a))}
                      [:span "×"]]
                     [:svg
                      {:class "comment-icon"
                       :height "16"
                       :width "16"
                       :viewBox "0 0 16 16"}
                      [:path
                       {:d
                        "M2.03 1.192h11.938c.847 0 1.531.71 1.531 1.587v6.748c0 .878-.685 1.587-1.531 1.587H13v3.693l-3.692-3.693H2.03c-.845 0-1.53-.709-1.53-1.587V2.78c0-.877.685-1.588 1.53-1.588z"}]
                      " "]
                     [:a {:class
                          ;; (<class $styles/alert-title-link)
                          $styles/$alert-title-link
                          :href (str "/t/" (string/replace-first (:id a) #"\+" ""))
                          :title link-txt
                          :on-click (fn [e] (on-click-alert-link e a))} link-txt]
                     [:span {:class
                            ;;  (<class $styles/alert-time-ago)
                             $styles/$alert-time-ago
                             } time-ago]
                     [:br]
                     [:span {:class
                            ;;  (<class $styles/thread-info)
                             $styles/$thread-info
                             } (str (:id a) " re. " forum-path-txt)]]))
                (when (> (count @alerts) 3)
                  (if (false? @show-all)
                    [:button {:class
                              ;; (<class $styles/show-all-btn)
                              $styles/$show-all-btn
                              :on-click (fn [e] (on-click-show-all e true))} "Show All"]
                    [:<>
                     [:button {:class
                              ;;  (<class $styles/show-less-btn)
                               $styles/$show-less-btn
                               :on-click (fn [e] (on-click-show-all e false))} "Show Less"]
                     [:button {:class
                              ;;  (<class $styles/del-all-btn)
                               $styles/$del-all-btn
                               :on-click (fn [e] (on-click-delete-all e @alerts))} "Delete All"]]))]))])))}))

(defn init-thread-alerts []
  (go-loop []
    (println "init-thread-alerts ZZZZZZZ")
    (when (auth/authenticated?)
      (let [
            ;; user (<! (firebase/wait-for-auth-user))
            user @(auth/user-atom)]
        ;; Safe to use Firebase Realtime DB now
        (js/console.log "Now operating as:" (.-uid user))
        (when (= (.-visibilityState js/document) "visible")
          (println "GETTING THREAD ALERTS")
          (get-thread-alerts (:uid @globals/fbjwt-payload) pause-int @ts-last-action))
        (<! (timeout 60000))
        (recur)))))


;; TODO: it will keep on adding init-thread-alerts to exec-on-fb-signing with every save and hot reload
;; think it's best to keep a map of keys and functions to execute and check if the key already exists before adding it
;; (swap! globals/exec-on-fb-sign-in #(conj @globals/exec-on-fb-sign-in init-thread-alerts)) 
(auth/on-auth-ready init-thread-alerts)

;; (println "@globals/exec-on-fb-sign-in:" @globals/exec-on-fb-sign-in)
